import { cn } from '@seen/ui'
import type { JSX } from 'react'

// Figma `triangle-inverted-filled` (813:8494): 24×24 outer box, ~20×18 inner
// leaf, shown at 6px. Tabler's same-named icon is a 21×18 glyph in that box
// and reads wide even at size-1.5; the path is the exported Figma vector.
export function FacesheetCollapseTriangle({
  className,
}: {
  className?: string
}): JSX.Element {
  return (
    <svg
      aria-hidden
      className={cn(
        'pointer-events-none size-1.5 shrink-0 text-foreground transition-transform duration-200 motion-reduce:transition-none',
        className
      )}
      data-slot="facesheet-triangle-inverted-filled"
      fill="currentColor"
      height="6"
      overflow="hidden"
      viewBox="0 0 24 24"
      width="6"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.0135 0C17.4863 0.00329488 17.9517 0.1183 18.3716 0.335635C18.7915 0.552971 19.1541 0.866482 19.4298 1.2506C19.7055 1.63472 19.8865 2.07857 19.9581 2.54594C20.0296 3.01332 19.9897 3.49099 19.8415 3.94L19.7735 4.125L19.7115 4.251L12.6215 16.484C12.3713 16.9368 12.0082 17.3172 11.5676 17.5882C11.127 17.8592 10.6237 18.0117 10.1067 18.0308C9.58977 18.0499 9.07663 17.9351 8.61717 17.6973C8.15771 17.4596 7.76754 17.1071 7.48454 16.674L7.38154 16.501L0.281539 4.251L0.220539 4.126C0.040451 3.68264 -0.0309612 3.20262 0.0122642 2.72604C0.0554897 2.24945 0.212098 1.79012 0.469016 1.38639C0.725934 0.982667 1.0757 0.646258 1.48913 0.405252C1.90255 0.164247 2.36763 0.0256387 2.84554 0.000999928L2.90354 0L2.96354 0.00200009L3.00654 0H17.0135Z"
        transform="translate(2.0037 3)"
      />
    </svg>
  )
}
